document.addEventListener('DOMContentLoaded', ()=>{
  if(window.location.href.includes("egate-career")){
      const jobs = document.querySelectorAll('.career-jobs-form--table .job-link');
      jobs.forEach((job)=>{
        job.addEventListener('click', ()=>{
          let jobKebab = job.innerText.replaceAll(" ", "-").toLowerCase();
          if(localStorage.getItem("CAREER_REDIRECT_KEY")){
            localStorage.removeItem("CAREER_REDIRECT_KEY")
              localStorage.setItem("CAREER_REDIRECT_KEY", JSON.stringify(jobKebab));
            console.log("Updated Successfully!")
          } else {
            localStorage.setItem("CAREER_REDIRECT_KEY", JSON.stringify(jobKebab));
            console.log("Created Successfully!")
          }
        })
      })
  }
})